import { Sms, SmsCollection } from 'src/dto'
import { AcademyPayment, StudentPayment } from 'src/dto/Payment'
import ExtendedDate from 'src/models/ExtendedDate'
import ExtendedMap from 'src/models/ExtendedMap'

import paymentApi from '@/api/payment.api'
import { PaymentMessageStatus, PaymentStudent, PaymentStudentColl } from '@/dto/Payment'

import { makeAdapter } from './Adapter'
import type Controller from './Controller'

type DateParams = {
  year: string
  month: string
}

const currentDate = new Date()
class PaymentController implements Controller {
  adapter = {
    payment: makeAdapter({
      from(data: res.AcademyPayment): AcademyPayment {
        return new AcademyPayment(data)
      },
    }),
    student: makeAdapter({
      from(data: res.StudentPayment[]) {
        const students = data.map((student) => new PaymentStudent(student))
        const studentColl = new PaymentStudentColl(ExtendedMap.fromArr(students, 'studentId'))

        return new StudentPayment(studentColl)
      },
    }),
    message: makeAdapter({
      from(data: res.PaymentMessageStatus): PaymentMessageStatus {
        const {
          messages: { content },
          ...rest
        } = data
        const smsArr = content.map((message) => new Sms(message))
        const messageColl = new SmsCollection(ExtendedMap.fromArr(smsArr, 'id'))
        return new PaymentMessageStatus({ messageColl, ...rest })
      },
    }),
  }

  async fetchAcademyPayment(
    yearMonth: DateParams | undefined = {
      year: currentDate.getFullYear().toString(),
      month: ExtendedDate.setPrefixMonth(currentDate.getMonth() + 1),
    },
  ) {
    const {
      data: { data },
    } = await paymentApi.getAcademyPayment(this.makeYearDashMonth(yearMonth))
    return this.adapter.payment.from(data)
  }

  async fetchAcademyStudentPayments(dateParams: DateParams) {
    const {
      data: { data },
    } = await paymentApi.getAcademyStudentPayments({
      yearMonth: this.makeYearDashMonth(dateParams),
    })
    return this.adapter.student.from(data)
  }

  async fetchPaymentMessage(pageQueryString: string, dateParams: DateParams) {
    const {
      data: { data },
    } = await paymentApi.getAcademyPaymentMessage(pageQueryString, this.getDateParams(dateParams))
    return { paymentMessageStatus: this.adapter.message.from(data), last: data.messages.last }
  }

  getDateParams({ year, month }) {
    return { yearMonth: year + '-' + month }
  }

  private makeYearDashMonth({ year, month }: DateParams) {
    return `${year}-${month}`
  }
}
export const paymentController = new PaymentController()
